module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/steps/rc-step03-6f29c9aeb54c0efb1846ce7f2a8a3bce.png";